export default __webpack_public_path__ + "static/media/phppgadmin.dab71e9c.svg";